import { getPersistor } from 'redux/store';

export const useDefaultOnReset = () => {
  const handler = () => {
    getPersistor()
      .purge()
      .then(() => {
        setTimeout(() => {
          window.history.replaceState(null, document.title);
        }, 200);
      });
  };

  return handler;
};
